var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormInformationFilm.jinja');
require('./SubmissionFormInformationFilm.less');

var moment = require('moment/moment');

var CommonCalendar = require('front/components/CommonCalendar/CommonCalendar');
var CommonCalendarTemplate = require('front/components/CommonCalendar/CommonCalendarRuntime.jinja');


var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'input input': 'onInputChange',
        'click .SubmissionFormInformationFilm-date': 'onCalendarClick'
    },

    initialize: function (options) {
        this.options = options || {};

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    onInputChange: function () {
        this.trigger('change');

        this.$('.SubmissionFormInformationFilm-date')
            .closest('.SubmissionFormElement-inputLine')
            .removeClass('SubmissionFormElement-inputLine--error');
    },


    onCalendarClick: function (e) {
        var $date = this.$('.SubmissionFormInformationFilm-date');

        if ($date.hasClass('SubmissionFormInformationFilm-date--calendar-opened')) {
            return;
        }

        var $calendar = $(CommonCalendarTemplate.render({data: {}}));

        $date.append($calendar);

        $date.addClass('SubmissionFormInformationFilm-date--calendar-opened');

        var calendar = new CommonCalendar({
            el: $calendar[0],
            date: $date.attr('data-date'),
            allowPastDates: true,
            warning: ''
        });

        calendar.show();

        calendar.on('close', function () {
            calendar.off();
            $date.removeClass('SubmissionFormInformationFilm-date--calendar-opened');
        });

        calendar.on('select', function (date) {
            var dateFrom = moment(date).startOf('day');

            $date
                .attr('data-date', dateFrom.format('YYYY-MM-DD'))
                .removeClass('SubmissionFormInformationFilm-date--empty')
                .find('span')
                .text(dateFrom.format('MM/DD/YY'));

            this.onInputChange();

        }.bind(this));
    },


    checkRequired: function () {
        var res = SubmissionFormBlock.prototype.checkRequired.call(this);

        //custom dates check
        if (res) {
            var $wrapper = this.$('.SubmissionFormInformationFilm-date').closest('.SubmissionFormElement-inputLine');
            var isRequired = $wrapper.find('.SubmissionFormElement-inputName').hasClass('SubmissionFormElement-inputName--required');

            res = !!this.getFormData().releaseDate;

            if (isRequired && !res) {

                $wrapper.addClass('SubmissionFormElement-inputLine--error');

                app.animateWindowScroll($wrapper.offset().top - 380);

                this.onCalendarClick();

                return false;
            }
        } else {
            return false;
        }

        return true;
    },


    getFormData: function () {
        return {
            'title': this.$('input[name="title"]').val(),
            'releaseDate': this.$('.SubmissionFormInformationFilm-date').attr('data-date') || null,
            'filmedInUs': this.$('input[name="filmedInUs"]:checked').val() == '1' ? true : this.$('input[name="filmedInUs"]:checked').val() == '0' ? false : null,
            'iatseAgreement': this.$('input[name="iatseAgreement"]:checked').val() == '1' ? true : this.$('input[name="iatseAgreement"]:checked').val() == '0' ? false : null,
            'description': this.$('textarea[name="description"]').val(),
            'productionCompany': this.$('input[name="productionCompany"]').val(),
            'productionPerson': this.$('input[name="productionPerson"]').val(),
            'productionPhone': this.$('input[name="productionPhone"]').val(),
            'productionEmail': this.$('input[name="productionEmail"]').val(),
            'distributionCompany': this.$('input[name="distributionCompany"]').val(),
            'distributionPerson': this.$('input[name="distributionPerson"]').val(),
            'distributionPhone': this.$('input[name="distributionPhone"]').val(),
            'distributionEmail': this.$('input[name="distributionEmail"]').val(),
            'awardsPerson': this.$('input[name="awardsPerson"]').val(),
            'awardsPhone': this.$('input[name="awardsPhone"]').val(),
            'awardsEmail': this.$('input[name="awardsEmail"]').val()
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormInformationFilm.js
// module id = 117
// module chunks = 0